import validatePhoneNumber from './phone-validator';
import 'intl-tel-input';
import {contactFormPhone} from '../pages/contact-us';
import AWN from "awesome-notifications";

$(".contact-form").on("submit", function(e){
     // Stop the browser from submitting the form.
    e.preventDefault();
    const serializedData = $(".contact-form").serializeArray();
    const captchaResponse = serializedData.find( obj => obj.name === "g-recaptcha-response");
    // Validate phone number input first
    const isPhoneValid = validatePhoneNumber(contactFormPhone) == true ? 1 : 0;
    var phoneErrorMsg = validatePhoneNumber(contactFormPhone);
    // Get recaptcha response
    const formData = {
        firstName: $(".contact-form").find("input[name='firstName']").val(),
        lastName: $(".contact-form").find("input[name='lastName']").val(),
        phoneNumber: isPhoneValid,
        email: $(".contact-form").find("input[name='email']").val(),
        website: $(".contact-form").find("input[name='website']").val(),
        servicesSelect: $(".contact-form").find("select[name='servicesSelect'] option:selected").val(),
        message: $(".contact-form").find("textarea[name='message']").val(),
        captchaResponse: captchaResponse["value"]
    }
    // Set preloader
    $("#contact-form-container").find(".section-preloader").removeClass("d-none");
    $("#contact-form-container").find(".section-preloader").animate({opacity: 1}, 1000);
    // Empty all errors lists container
    $("ul.error-list").empty();
    // Create new promise to handle notifications with awesome-notifications
    let promise = $.ajax({
        url: global_vars.ajaxurl,
        type: 'POST',
        data:{
            action: "hsm_send_contact_form",
            security: theme_vars.ajax_nonce,
            form: JSON.stringify(formData)
        }
    });
    // Handle response behavior with awesome-notifications
    let notifier = new AWN();
    notifier.asyncBlock(
        promise,
        // On success 
        function(response){
            const errors = response.data;
            // Check for errors
            if (errors.length  <= 0 && isPhoneValid){
                // Handle ajax success
                notifier.success(`Your form has been sent succesfully.`);
            }else{
                notifier.alert("Woops, there's something wrong. Please check your info and try again");
                // Inject errors
                if (isPhoneValid != 1){
                    $(`ul.error-list[data-name="phoneNumber"]`).removeClass('d-none');
                    $(`ul.error-list[data-name="phoneNumber"]`).append(
                        `<li class="text-danger small">${phoneErrorMsg}</li>`
                    );
                }
                const errorsArr = Object.entries(errors)
                for(const[field,errors] of errorsArr){
                    for(const error of errors){
                        $(`ul.error-list[data-name="${field}"]`).removeClass('d-none');
                        $(`ul.error-list[data-name="${field}"]`).append(
                            `<li class="text-danger small">${error}</li>`
                            );
                        }
                }
            }
        },
        // On reject
        function(response){
            notifier.alert("Something went wrong, please try again later");
        });
});